module.exports = __webpack_public_path__ + "img/user.e6d32395.svg";